import Pusher from 'pusher-js';
import env from '../env';

Pusher.logToConsole = true; // Enable Pusher debug logging

class PusherService {
    constructor() {
        this.pusher = new Pusher("7940b2a8c2463a645e40", {
            cluster: "ap1",
            encrypted: true,
            authEndpoint: `${env.API_URL}/presence/authenticate`,
            auth: {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Accept': 'application/json',
                }
            }
        });
    }

    // Auction channels
    subscribeToAuction(auctionId, callback) {
        const channel = this.pusher.subscribe(`auction.${auctionId}`);
        channel.bind('auction.updated', callback);
        return () => {
            channel.unbind('auction.updated');
            this.pusher.unsubscribe(`auction.${auctionId}`);
        };
    }

    // Lot channels
    subscribeToLot(auctionId, lotId, callback) {
        const channel = this.pusher.subscribe(`lot.${auctionId}.${lotId}`);
        channel.bind('lot.updated', callback);
        channel.bind('bid.placed', callback);
        channel.bind('bid.updated', callback);
        return () => {
            channel.unbind('lot.updated');
            channel.unbind('bid.placed');
            channel.unbind('bid.updated');
            this.pusher.unsubscribe(`lot.${auctionId}.${lotId}`);
        };
    }

    // Bid channels
    subscribeToBids(auctionId, lotId, callback) {
        const channel = this.pusher.subscribe(`bids.${auctionId}.${lotId}`);
        channel.bind('bid.placed', callback);
        channel.bind('bid.updated', callback);
        return () => {
            channel.unbind('bid.placed');
            channel.unbind('bid.updated');
            this.pusher.unsubscribe(`bids.${auctionId}.${lotId}`);
        };
    }

    // Price updates
    subscribeToPriceUpdates(auctionId, lotId, callback) {
        const channel = this.pusher.subscribe(`price.${auctionId}.${lotId}`);
        channel.bind('price.updated', callback);
        return () => {
            channel.unbind('price.updated');
            this.pusher.unsubscribe(`price.${auctionId}.${lotId}`);
        };
    }

    // Global notifications
    subscribeToNotifications(userId, callback) {
        const channel = this.pusher.subscribe(`notifications.${userId}`);
        channel.bind('notification', callback);
        return () => {
            channel.unbind('notification');
            this.pusher.unsubscribe(`notifications.${userId}`);
        };
    }

    // Presence channels for Connected Users
    subscribeToPresence(auctionId, callbacks) {
        const channelName = `presence-auction.${auctionId}`;
        console.log('🔌 Attempting to subscribe to presence channel:', channelName);
        console.log('🔌 Pusher instance:', this.pusher);
        console.log('🔌 Pusher connection state:', this.pusher.connection.state);
        
        const channel = this.pusher.subscribe(channelName);
        
        // Add general error handling
        channel.bind('pusher:error', (error) => {
            console.error('🚨 Pusher channel error:', error);
        });
        
        // Add general event listeners for debugging
        channel.bind('pusher:member_removed', (data) => {
            console.log('🔍 Raw pusher:member_removed event:', data);
        });
        
        channel.bind('pusher_internal:member_removed', (data) => {
            console.log('🔍 Raw pusher_internal:member_removed event:', data);
        });
        
        // Add connection state monitoring
        this.pusher.connection.bind('state_change', (states) => {
            console.log('🔄 Pusher connection state changed:', states.previous, '->', states.current);
        });
        
        // Bind presence events
        if (callbacks.onMemberAdded) {
            channel.bind('pusher:member_added', callbacks.onMemberAdded);
        }
        if (callbacks.onMemberRemoved) {
            channel.bind('pusher:member_removed', callbacks.onMemberRemoved);
        }
        if (callbacks.onSubscriptionSucceeded) {
            channel.bind('pusher:subscription_succeeded', callbacks.onSubscriptionSucceeded);
        }
        if (callbacks.onSubscriptionError) {
            channel.bind('pusher:subscription_error', callbacks.onSubscriptionError);
        }

        return () => {
            console.log('🔌 Unsubscribing from presence channel:', channelName);
            if (callbacks.onMemberAdded) {
                channel.unbind('pusher:member_added');
            }
            if (callbacks.onMemberRemoved) {
                channel.unbind('pusher:member_removed');
            }
            if (callbacks.onSubscriptionSucceeded) {
                channel.unbind('pusher:subscription_succeeded');
            }
            if (callbacks.onSubscriptionError) {
                channel.unbind('pusher:subscription_error');
            }
            this.pusher.unsubscribe(channelName);
        };
    }

    // Cleanup
    disconnect() {
        this.pusher.disconnect();
    }
}

export default new PusherService(); 